import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
}), 'PlaylistAddOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlaylistAddOutlined.js
// module id = 5528
// module chunks = 2